var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative cursor-pointer w-full text-center transition-colors duration-150",class:{
    'text-white': _vm.bright && _vm.active,
    'text-gray-500': _vm.bright && !_vm.active,
    'bg-gray-200 text-gray-500': _vm.popped && !_vm.active,
    'border border-gray-500 -mb-px text-gray-900': _vm.popped && _vm.active,
    'text-black': !_vm.bright && !_vm.popped && _vm.active,
    'text-gray-700': !_vm.bright && !_vm.popped && !_vm.active
  },on:{"click":_vm.emitInput}},[_c('div',{staticClass:"p-2 text-sm tracking-widest z-10"},[_vm._t("default")],2),(!_vm.popped && _vm.active)?_c('div',{staticClass:"mb-1 mx-8 border-b border-b-2",class:{
      'border-gray-800': !_vm.bright,
    }}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }